import { useEffect, useState } from 'react';
import { tail } from 'ramda';
import { b64toBlob, downloadBlob } from 'utilities';

export default function useExport(request, patientId = '', observationId = '') {
  const [isLoadingExport, setLoadingExport] = useState(false);
  useEffect(() => {
    if (!isLoadingExport) return;
    const loadExport = async () => {
      const data = await request({ patientId, observationId });
      const contentType = data.headers['content-type'].split(';')[0];
      const filePattern = /filename=(.*)/;
      const filename = filePattern.exec(data.headers['content-disposition']);
      const file =
        contentType === 'application/pdf'
          ? b64toBlob(data.data.content[0].data)
          : new Blob([data.data], { type: contentType });
      downloadBlob(URL.createObjectURL(file), tail(filename));
      setLoadingExport(false);
    };

    loadExport();
  }, [isLoadingExport, patientId, request, observationId]);

  return [setLoadingExport];
}
